module.exports = __webpack_public_path__ + "static/media/logo ATLANTIDE.81ff7592.png";